<script>
	import { format } from "@formkit/tempo"
	const date = new Date()
	format(date, "full")
	const readable = format(new Date(), "full")

	
	let texto = '';

	function alerta1(){
		alert('ABUELA LLEGO SU NIETO YA LLEGUE')

	}
	const alerta2 = () => alert('SEGUNDO LUGAR') 
	
	let contador = 1;

	$:resultado = contador * 10

	$:if (resultado === 30){
		texto = 'bien';
	}else{
		texto = 'ou';
	};
	const cambio = ( ) => login = !login;

 let login = false

	let check = false
	let nombre = "Vicente";
	let v1 = 0
	let v2 = 0


	let nombres = ['Vicente','Cristian','Ivan'];

	let personas = [{"id":1,"nombre":"Devan","apellido":"Mordey","email":"dmordey0@google.com.br"},
{"id":2,"nombre":"Tobi","apellido":"Knudsen","email":"tknudsen1@cbc.ca"},
{"id":3,"nombre":"Thia","apellido":"Rosengarten","email":"trosengarten2@posterous.com"},
{"id":4,"nombre":"Willy","apellido":"Sterling","email":"wsterling3@blogspot.com"},
{"id":5,"nombre":"Wes","apellido":"Chaffin","email":"wchaffin4@myspace.com"},
{"id":6,"nombre":"Martyn","apellido":"Nicholson","email":"mnicholson5@dmoz.org"},
{"id":7,"nombre":"Lannie","apellido":"Gallatly","email":"lgallatly6@senate.gov"},
{"id":8,"nombre":"Mirella","apellido":"De Ruel","email":"mderuel7@facebook.com"},
{"id":9,"nombre":"Sunny","apellido":"Stening","email":"sstening8@odnoklassniki.ru"},
{"id":10,"nombre":"Newton","apellido":"Hatchman","email":"nhatchman9@ebay.co.uk"},
{"id":11,"nombre":"Karalee","apellido":"Ogle","email":"koglea@ted.com"},
{"id":12,"nombre":"Tobye","apellido":"Hefner","email":"thefnerb@goo.ne.jp"},
{"id":13,"nombre":"Krissie","apellido":"Pimm","email":"kpimmc@jugem.jp"},
{"id":14,"nombre":"Hadley","apellido":"Bouller","email":"hboullerd@elpais.com"},
{"id":15,"nombre":"Elizabet","apellido":"Shevlan","email":"eshevlane@wufoo.com"},
{"id":16,"nombre":"Gris","apellido":"Karpenko","email":"gkarpenkof@buzzfeed.com"},
{"id":17,"nombre":"Ermina","apellido":"Morecombe","email":"emorecombeg@dagondesign.com"},
{"id":18,"nombre":"Florrie","apellido":"Roylance","email":"froylanceh@yahoo.co.jp"},
{"id":19,"nombre":"Jessi","apellido":"Scarrisbrick","email":"jscarrisbricki@rambler.ru"},
{"id":20,"nombre":"Lura","apellido":"Questier","email":"lquestierj@howstuffworks.com"}]

let promesa = ajax();
let users = [];
const url = 'https://jsonplaceholder.typicode.com/users';
async  function ajax(){
	const res = await fetch(url)
	users = await res.json()
	await sleep(3000)
	if(res.ok){
		return users
	}
	else{
		throw new Error('error para conectar con la api')
	}
		function sleep(s){
			return new Promise (res => setTimeout(res,s))
		}
}



</script>

<main>
	<h1>DataBending</h1>
	<h2>{nombre}</h2>
	<h4>{readable}</h4>
	<h3>{date}</h3>
	<input type="XD" bind:value={nombre}>
	<hr>
	valor 1 <input type="range" bind:value={v1}>
	valor 2 <input type="range" bind:value={v2}>
	<p>{v1} + {v2} = {v1 + v2}</p>
	<hr>
	boton <input type="checkbox" bind:checked={check}>
	<button disabled={!check}>Guardar</button>
 	<h1 >Button </h1>
 		<button on:click={alerta1}>alerta 1</button>
		<button on:click={alerta2}>abuelita</button>
		<button on:click={() => alert('arrow funciont')}>Alerta 3</button>
		<hr>
		<h1>Variables Reactivas</h1>
		<button on:click={() => contador += 1}>contador</button>
		<p>contador : {contador}, resultado x 10: {resultado}</p>
		<p>{texto}</p>
		
		
		<hr>
		<h1>Bloque if</h1>
		{#if login }
		<h2>estas login</h2>

		{:else}
		<h3>no estas logeado</h3>
		{/if}
		<button on:click={cambio}>Logearse</button>
		<hr>
		<h1>Bloque Each</h1>
		<ul>
			
				{#each nombres as nombre}
				<li>{nombre}</li>
				{/each}
			
		</ul>
		<hr>
		
		<table align="center">
			<th>nombres</th>
			<th>apellido</th>
			<th>email</th>
			{#each personas as item}
			<tr>
				<td>{item.apellido}</td>
				<td>{item.nombre}</td>
				<td>{item.email}</td>

			</tr>
			{:else}
				<tr colspan='3'>La api no tiene datos</tr>
				
			{/each}

		</table>
		<hr>
		<h1>Bloque await</h1>
		{#await promesa}
		<p>Cargando api...</p>
			
		{:then usuarios} 
		<p>funciona correctamente</p>
		{#each usuarios as item}
				<li>{item.name}</li>
				{/each}

		{:catch error}
		<p style="color: blueviolet;">{error}</p>
			
		{/await}

		


	
	
</main>

<style>
	
	h2 {
		color: blueviolet;
	}
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>